'use client';

import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from '@/components/ui/dialog';
import { TerminalDocument } from './terminal/TerminalDocument';
import { PRIVACY_POLICY_CONTENT } from '@/lib/legal/privacy-policy';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface PrivacyPolicyModalProps {
  children: React.ReactNode;
  className?: string;
  // Allow external control for direct linking
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function PrivacyPolicyModal({
  children,
  className = '',
  open: externalOpen,
  onOpenChange: externalOnOpenChange
}: PrivacyPolicyModalProps) {
  const [internalOpen, setInternalOpen] = useState(false);

  // Use external state if provided, otherwise internal state
  const isOpen = externalOpen !== undefined ? externalOpen : internalOpen;
  const setIsOpen = externalOnOpenChange || setInternalOpen;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild className={className}>
        {children}
      </DialogTrigger>
      <DialogContent 
        className="max-w-5xl max-h-[90vh] p-0 bg-transparent border-none shadow-none overflow-hidden"
        hideOverlay={true}
      >
        <VisuallyHidden>
          <DialogTitle>Privacy Policy</DialogTitle>
        </VisuallyHidden>
        <TerminalDocument
          title="Privacy Policy v2025.1.0"
          content={PRIVACY_POLICY_CONTENT}
          onClose={() => setIsOpen(false)}
          showLineNumbers={true}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PrivacyPolicyModal;